import React, { Component } from "react"

class Game extends Component {
  constructor(props) {
    super(props);
    this.lang = this.props.match.params.lang;
    let data;
    if (this.lang === 'rus') {
      data = require('../static/rus.json')
    } else {
      data = require('../static/esp.json')
    }
    this.words = [];
    let i;
    for (i = 0; i < data.length; i++) {
      this.words.push(data[i]);
    }

    this.state = {
      count: -1,
      correct: 0,
      answerpos: 0,
      lastpos: 0,
      target: "",
      choices: ["1", "2", "3", "4"],
      msg: "",
      isEng: true
    }
    this.chose = this.chose.bind(this);
    this.switchLang = this.switchLang.bind(this);
  }

  switchLang() {
    console.log(this.state.isEng)
    let swap = !this.state.isEng
    console.log(swap)
    this.state.isEsp = !this.state.isEng
    console.log(this.state.isEng)

    this.chose(-1);
  }

  render() {
    return (
      <center>
        <img id="bkg" src={this.lang === 'rus' ? "../rusBkg.jpeg" : "../espBkg.jpg"} alt="bkg" />

        <p id="score">
          Score: {this.state.correct} / {this.state.count}
        </p>

        <p id="msg">
          {this.state.msg}
        </p>
        <button type="button" onClick={this.switchLang}>
          {this.lang === 'rus' ? 'рус - анг' : 'esp - ing'}
        </button>
        <h2 className="cardText" id="cardDiv">
          {this.state.target}
        </h2>
        <div id="choices">
          <button onClick={() => this.chose(0)}>
            {this.state.choices[0]}
          </button>
          <button onClick={() => this.chose(1)}>
            {this.state.choices[1]}
          </button>
          <button onClick={() => this.chose(2)}>
            {this.state.choices[2]}
          </button>
          <button onClick={() => this.chose(3)}>
            {this.state.choices[3]}
          </button>
        </div>
      </center>
    );
  }

  componentDidMount() {
    this.chose(-1);
  }

  chose(choice) {
    console.log("choice" + choice + "ans" + this.state.lastpos)
    if (choice === -1) {
      this.setState({
        msg: this.lang === 'rus' ? 'выберите правильный перевод' : "Elija la traducción correcta"
      });
    } else if (choice === this.state.lastpos) {
      this.setState({
        msg: this.lang === 'rus' ? "ура правильно!" : "¡Correcto!",
        correct: this.state.correct + 1
      });
    } else {
      this.setState({
        msg: (this.lang === 'rus' ? "неправильно! " : "¡Incorrecto! ") + this.state.target + " = " + this.state.choices[this.state.lastpos]
      });
    }

    let card = this.words[rand(this.words.length)];
    console.log(card)
    let targ, ans;
    if (this.state.isEng) {
      targ = card.eng;
      ans = card.tran;
    } else {
      targ = card.tran;
      ans = card.eng;
    }
    console.log(targ);
    this.setState({
      count: this.state.count + 1,
      lastpos: this.state.answerpos,
      answerpos: rand(4),
      target: targ
    });

    let i;
    for (i = 0; i < 4; i++) {
      if (this.state.answerpos === i) {
        this.state.choices[i] = ans;
      } else {
        card = this.words[rand(this.words.length)];
        if (this.state.isEng) {
          this.state.choices[i] = card.tran;
        } else {
          this.state.choices[i] = card.eng;
        }
      }
    }
  }
}

function rand(max) {
  return Math.floor(Math.random() * Math.floor(max));
}

export default Game;